import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './components/MainPage';
import ProfessionalsPage from './components/ProfessionalsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/professionals" element={<ProfessionalsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
